import { useState } from 'react';

import CommentaryList from '../../common/CommentaryList/CommentaryList';
import InfoBlock from '../../common/InfoBlock/InfoBlock';
import InfoLine from '../../common/InfoBlock/InfoLine';

import { Badge, Button, Heading, Icon, Pane, Tab, Table, Text, TruckIcon, UserIcon, WarningSignIcon } from 'evergreen-ui';
import moment from 'moment';
import CombineOrderModal from './CombineOrderModal';
import HistoryModal from './HistoryModal';
import OrderControl from './OrderControl';
import OrderShipmentsPanel from './OrderShipmentsPanel';

export default function OrderInfoBlock(props) {
    const BV_STOCK_ACCOUNT_ID = 4;
    const [selectedTab, setSelectedTab] = useState('info');
    const [commentTab, setCommentTab] = useState('issues');
    const [showHistoryModal, setShowHistoryModal] = useState(false);
    const [showCombineOrderModal, setShowCombineOrderModal] = useState(false);
    const hasIssues = props.order.issues > 0;
    const attribution = props.order.attribution || {};
    const hasAttribution = ['gclid', 'fbclid', 'fbc', 'fbp', 'gaClientId'].some(k => attribution[k]);

    return <Pane width="100%">
         <HistoryModal
            order={props.order}
            open={showHistoryModal}
            onClose={() => setShowHistoryModal(false)}/>

        <CombineOrderModal
            order={props.order}
            open={showCombineOrderModal}
            onClose={() => setShowCombineOrderModal(false)}/>

        <Pane marginBottom={20}>
            <Tab isSelected={selectedTab === 'info'} onSelect={() => setSelectedTab('info')}>
                Info
            </Tab>
            <Tab isSelected={selectedTab === 'products'} onSelect={() => setSelectedTab('products')}>
                Produse ({props.order.items ? props.order.items.length : '-'})
            </Tab>
            <Tab isSelected={selectedTab === 'return'} onSelect={() => setSelectedTab('return')}>
                Detalii Retur
            </Tab>
            <Tab isSelected={selectedTab === 'review'} onSelect={() => setSelectedTab('review')}>
                Recenzie {props.order.review ? `(${props.order.review.rating}★)` : ''}
            </Tab>
            <Tab isSelected={selectedTab === 'attribution'} onSelect={() => setSelectedTab('attribution')}>
                Atribuire
            </Tab>
            <Tab isSelected={selectedTab === 'shipments'} onSelect={() => setSelectedTab('shipments')}>
                Expedieri
            </Tab>


            <Button type="button" onClick={() => setShowHistoryModal(true)}>
                Istoric Livrare Comanda
            </Button>

            <Button type='button' onClick={() => setShowCombineOrderModal(true) } marginLeft={10}>
                Combina cu alta comanda
            </Button>



        </Pane>
        <Pane display="flex">
        {
            selectedTab === 'review' ?
            <InfoBlock
                flex="50%"
                marginRight={16}
                label={'Recenzie Client'}>

                {props.order.review ? <>
                    <Pane display="flex" alignItems="center" marginBottom={16}>
                        <Pane display="flex" alignItems="center">
                            {[1, 2, 3, 4, 5].map((star) => (
                                <Text
                                    key={star}
                                    fontSize={24}
                                    color={star <= props.order.review.rating ? '#fbbf24' : '#d1d5db'}
                                >
                                    ★
                                </Text>
                            ))}
                        </Pane>
                        <Text marginLeft={10} fontWeight="bold">
                            {props.order.review.rating}/5
                        </Text>
                    </Pane>

                    {props.order.review.comment ? (
                        <Pane background="tint1" padding={16} borderRadius={4}>
                            <Heading size={100} marginBottom={8}>Comentariu:</Heading>
                            <Text>{props.order.review.comment}</Text>
                        </Pane>
                    ) : (
                        <Text color="muted">Clientul nu a lăsat un comentariu.</Text>
                    )}

                    <Pane marginTop={16}>
                        <InfoLine
                            label="Data recenzie"
                            value={moment(props.order.review.createdAt).format('DD/MM/YYYY HH:mm')}
                        />
                    </Pane>
                </> : (
                    <Pane display="flex" flexDirection="column" alignItems="center" padding={32}>
                        <Text color="muted" fontSize={16}>
                            Nu există recenzie pentru această comandă.
                        </Text>
                        {props.order.status === 'completed' && (
                            <Text color="muted" fontSize={12} marginTop={8}>
                                Link recenzie: https://krit.ro/recenzie-comanda?orderNumber={props.order.orderNumber}&referenceId={props.order.referenceId}
                            </Text>
                        )}
                    </Pane>
                )}
            </InfoBlock> : null}
        {
            selectedTab === 'return' ?
            <InfoBlock
                flex="50%"
                marginRight={16}
                label={'Retururi'}>

                {props.order.refundData ? <>
                    {props.order.refundData.map((refund, index) => (<>
                        <Heading size={200}>Retur {index+1}</Heading>
                        <InfoLine label="Plata Retur" value={refund.refundType === 'cash' ? 'Numerar' : 'Transfer Bancar'}/>
                        {refund.refundType !== 'cash' ? <>
                            <InfoLine label="Cont Retur" value={refund.refundAccount}/>
                            <InfoLine label="Nume Retur" value={refund.refundName}/> </>
                        : null}
                        <InfoLine label="Valoare Retur" value={`${refund.refundValue} RON`}/>
                        <InfoLine label="Platit" value={refund.paid ? 'Da' : 'Nu'}/>

                        </>
                    ))}

                </> : null}
            </InfoBlock> : null}
        {selectedTab === 'attribution' ?
            <InfoBlock
                flex="50%"
                marginRight={16}
                label={'Atribuire marketing'}>

                {hasAttribution ? <>
                    <InfoLine label="Google Click ID" value={attribution.gclid || '-'} />
                    <InfoLine label="Facebook Click ID" value={attribution.fbclid || '-'} />
                    <InfoLine label="Meta _fbc" value={attribution.fbc || '-'} />
                    <InfoLine label="Meta _fbp" value={attribution.fbp || '-'} />
                    <InfoLine label="GA Client ID" value={attribution.gaClientId || '-'} />
                </> : (
                    <Pane padding={16}>
                        <Text color="muted">Comanda nu are date de atribuire (trafic direct / organic).</Text>
                    </Pane>
                )}

                <Heading size={500} marginTop={20} borderBottom="1px solid #aaaaaa">SESIUNE</Heading>
                <InfoLine label="IP client" value={attribution.clientIp || '-'} />
                <InfoLine label="User Agent" value={attribution.clientUserAgent || '-'} />

                <Heading size={500} marginTop={20} borderBottom="1px solid #aaaaaa">CONVERSIE</Heading>
                <InfoLine
                    label="Conversie trimisa"
                    value={attribution.conversionSentAt
                        ? moment(attribution.conversionSentAt).format('DD/MM/YYYY HH:mm:ss')
                        : 'Netrimisa'} />
            </InfoBlock> : null}
        {selectedTab === 'shipments' ?
            <InfoBlock
                flex="100%"
                marginRight={16}
                label={`Expedieri comanda`}>
                <OrderShipmentsPanel order={props.order} />
            </InfoBlock> : null}
        {selectedTab === 'info' ?
            <InfoBlock
                flex="50%"
                marginRight={16}
                label={`Detalii comanda`}
                button={{
                    link: `/orders/${props.order.id}/edit`,
                    label: 'Modifica'
                }}
            >
                <Pane>
                    {/* Commentary / Issues section */}
                    {hasIssues ? (
                        <Pane
                            marginBottom={16}
                            border="1px solid #E4E7EB"
                            borderRadius={4}
                            background="white"
                            overflow="hidden">
                            <Pane
                                display="flex"
                                background="tint1"
                                borderBottom="1px solid #E4E7EB"
                                paddingX={8}
                                paddingTop={8}>
                                <Tab isSelected={commentTab === 'issues'} onSelect={() => setCommentTab('issues')}>
                                    Comanda are tickete ({props.order.issues})
                                </Tab>
                                <Tab isSelected={commentTab === 'comments'} onSelect={() => setCommentTab('comments')}>
                                    Comentarii
                                </Tab>
                            </Pane>

                            <Pane padding={16}>
                                {commentTab === 'issues' ? (
                                    <Pane
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="space-between">
                                        <Pane display="flex" alignItems="center">
                                            <Icon icon={WarningSignIcon} color="warning" marginRight={12} size={20} />
                                            <Pane>
                                                <Heading size={400}>Comanda are tickete deschise</Heading>
                                                <Text color="muted">
                                                    {props.order.issues} {props.order.issues === 1 ? 'ticket deschis' : 'tickete deschise'}
                                                </Text>
                                            </Pane>
                                        </Pane>
                                        <Button
                                            iconBefore="warning-sign"
                                            intent="warning"
                                            appearance="primary"
                                            onClick={props.onOpenIssues}>
                                            Vezi ticketele
                                        </Button>
                                    </Pane>
                                ) : (
                                    <CommentaryList
                                        activity={props.order.activity || []}
                                        onAddComment={props.onAddActivity}
                                        title="Comentarii"
                                        maxVisibleComments={2}
                                    />
                                )}
                            </Pane>
                        </Pane>
                    ) : (
                        <CommentaryList
                            activity={props.order.activity || []}
                            onAddComment={props.onAddActivity}
                            title="Comentarii"
                            maxVisibleComments={2}
                        />
                    )}

                    <InfoLine label="Tip" value={props.order.orderTypeText} />
                    <InfoLine label="Livrare" value={props.order.deliveryText} />

                    {['delivery', 'delivery-locker'].includes(props.order.delivery) ?
                        <InfoLine label="AWB" value={props.order.deliveryReference || "N/A"}/> : null}

                    <InfoLine label="Status" value={props.order.statusText}/>
                    <InfoLine label="Status Plata" value={props.order.paymentStatusText}/>
                    {props.order.delivery === "delivery" && props.order.status === "delivered" ?
                        <InfoLine label="Status Livrare" value={props.order.deliveryStatusText}/> : null}


                    {/* <InfoLine label="Cost Transport" value={`${props.order.shippingCost} RON (Real: ${props.order.realShippingCost} RON)`}/> */}
                    <InfoLine label="Total Comanda" value={`${props.order.grandTotal} RON`}/>
                    <InfoLine label="Plasata la" value={`${moment(props.order.createdAt).format('DD/MM/YYYY HH:mm:ss')}`}/>

                    {props.order.email || props.order.billingPhoneNumber || props.order.deliveryPhoneNumber ? <>
                        <Heading size={600} marginBottom={20} marginTop={20} borderBottom="1px solid #aaaaaa">Contact</Heading>
                        {props.order.email ?
                            <Pane display="flex" marginBottom={4} borderBottom="default">
                                <Pane padding={8} width={150} minWidth={150}>
                                    <Text><strong>Email</strong></Text>
                                </Pane>
                                <Pane flexGrow={1} padding={8} display="flex" alignItems="center">
                                    <Text>{props.order.email}</Text>
                                    {props.order.emailOrderCount !== undefined && (
                                        <Badge color={props.order.emailOrderCount > 1 ? 'green' : 'neutral'} marginLeft={8}>
                                            {props.order.emailOrderCount} {props.order.emailOrderCount === 1 ? 'comanda' : 'comenzi'}
                                        </Badge>
                                    )}
                                    {props.order.userId && (
                                        <Icon
                                            icon={UserIcon}
                                            size={16}
                                            cursor="pointer"
                                            color="default"
                                            marginLeft={8}
                                            onClick={() => window.open(`/users/${props.order.userId}`, '_blank', 'noopener,noreferrer')}
                                            title="View user account"
                                        />
                                    )}
                                </Pane>
                            </Pane>
                        :null}

                        {props.order.billingPhoneNumber ?
                            <InfoLine label="Nr. Telefon Comanda" value={props.order.deliveryPhoneNumber} />
                        :null}

                        {props.order.deliveryPhoneNumber ?
                            <InfoLine label="Nr. Telefon Livrare" value={props.order.deliveryPhoneNumber} />
                        :null}
                    </> : null}
                </Pane>

                {props.order.orderType !== 'glovo' ? <>
                        <Pane marginRight={10} marginTop={20}>
                            <Pane flexGrow="0.5" marginRight={10}>
                                <Heading size={500} marginTop={10} borderBottom="1px solid #aaaaaa">FACTURARE</Heading>
                                <InfoLine label="Nume" value={props.order.billingName} />

                                {props.order.billingIsExternal ? <>
                                    {/* Foreign invoice address — free-text holders, no RO city/county row. */}
                                    <InfoLine label="Tara" value={props.order.billingCountryText || props.order.billingCountry} />
                                    <InfoLine label="Oras" value={props.order.billingCityName || 'N/A'} />
                                    <InfoLine label="Cod Postal" value={props.order.billingPostCode || 'N/A'} />
                                    <InfoLine label="Adresa" value={props.order.billingAddress || 'N/A'} />
                                    {props.order.billingAddress2 ? <InfoLine label="Adresa 2" value={props.order.billingAddress2} /> : null}
                                    <InfoLine label="Tel." value={props.order.billingPhoneNumber} />
                                </> : <>
                                    {props.order.billingLocation  ? <>
                                    <InfoLine label="Adresa" value={props.order.billingLocation ? props.order.billingLocation.publicName : 'Format Vechi'}/>
                                    <InfoLine label="Detalii Adresa" value={props.order.billingAddress} />
                                    <InfoLine label="Cod Postal" value={props.order.billingLocation ? props.order.billingLocation.postcode : 'Format Vechi'}/>
                                    </> : <>
                                        <InfoLine label="Oras" value={`${props.order.billingCity ? props.order.billingCity.name : '-'} (${props.order.billingCounty ? props.order.billingCounty.name : '-'})` || 'N/A'}/>
                                        <InfoLine label="Adresa" value={props.order.billingAddress || 'N/A'}/>
                                    </>}

                                    <InfoLine label="Tel." value={props.order.billingPhoneNumber} />
                                    <InfoLine label="Judet" value={props.order.billingLocation ? props.order.billingLocation.countyName : (props.order.billingCounty || { name: 'N/A' }).name} />
                                    <InfoLine label="Oras" value={props.order.billingLocation ? props.order.billingLocation.cityName : (props.order.billingCity || { name: 'N/A' }).name} />
                                </>}
                            </Pane>

                            <Pane flexGrow="0.5">
                                <Heading size={500} marginTop={30} borderBottom="1px solid #aaaaaa">LIVRARE</Heading>
                                <InfoLine label="Client" value={props.order.entityTypeText} />
                                <InfoLine label="Nume" value={props.order.deliveryName} />

                                {props.order.delivery !== 'delivery-locker' ? <>
                                    {props.order.isExternal ? <>
                                        {/* Foreign orders have no RO city/county rows — show the free-text holders. */}
                                        <InfoLine label="Tara" value={props.order.deliveryCountryText || props.order.deliveryCountry} />
                                        <InfoLine label="Oras" value={props.order.deliveryCityName || 'N/A'} />
                                        <InfoLine label="Cod Postal" value={props.order.deliveryPostCode || 'N/A'} />
                                        <InfoLine label="Adresa" value={props.order.deliveryAddress || 'N/A'} />
                                        {props.order.deliveryAddress2 ? <InfoLine label="Adresa 2" value={props.order.deliveryAddress2} /> : null}
                                    </> : <>
                                        {props.order.deliveryLocation ? <>
                                            <InfoLine label="Adresa" value={props.order.billingLocation ? props.order.billingLocation.publicName : 'Format Vechi'}/>
                                            <InfoLine label="Detalii Adresa" value={props.order.billingAddress} />
                                            <InfoLine label="Cod Postal" value={props.order.billingLocation ? props.order.billingLocation.postcode : 'Format Vechi'}/>
                                        </> : <>
                                            <InfoLine label="Oras" value={`${props.order.deliveryCity ? props.order.deliveryCity.name : '-'} (${props.order.deliveryCounty ? props.order.deliveryCounty.name : '-'})` || 'N/A'}/>
                                            <InfoLine label="Adresa" value={props.order.deliveryAddress || 'N/A'}/>
                                        </>}
                                        <InfoLine label="Judet" value={props.order.deliveryLocation ? props.order.deliveryLocation.countyName : (props.order.deliveryCounty || { name: 'N/A' }).name} />
                                        <InfoLine label="Oras" value={props.order.deliveryLocation ? props.order.deliveryLocation.cityName : (props.order.deliveryCity || { name: 'N/A' }).name} />
                                    </>}
                                </> : <>
                                    <InfoLine label="Easybox" value={`${props.order.deliveryLockerName} (${props.order.deliveryLockerId})` || 'N/A'}/>
                                </>}
                                <InfoLine label="Tel." value={props.order.deliveryPhoneNumber} />



                                {props.order.entityType === "pj" ? <>
                                    <InfoLine label="Nume Companie" value={props.order.companyName} />
                                    <InfoLine label="CUI/CIF" value={props.order.vatNumber} />
                                    <InfoLine label="NORC" value={props.order.registryNumber} />
                                </> : null}
                            </Pane>
                        </Pane>
                    </> : null}
            </InfoBlock> : null}

        {selectedTab === 'products' ?
            <InfoBlock
                flex="50%"
                marginRight={16}
                label={`Produse`}
            >
                <Pane display="flex" flexDirection="column">
                    <Pane marginRight={10} flexGrow="1">
                        <Pane>
                            <Table>
                                <Table.Head>
                                    <Table.TextHeaderCell colspan="4">
                                        Locatie
                                    </Table.TextHeaderCell>
                                    <Table.TextHeaderCell>
                                        Pret Unitar
                                    </Table.TextHeaderCell>
                                    <Table.TextHeaderCell>
                                        Cantitate
                                    </Table.TextHeaderCell>

                                    <Table.TextHeaderCell>
                                        Pret Total
                                    </Table.TextHeaderCell>

                                    <Table.TextHeaderCell>
                                        Total Linie
                                    </Table.TextHeaderCell>
                                </Table.Head>
                                <Table.Body>

                                    {props.order.items ? props.order.items.map(product => (<>
                                        <Table.Row key={`pre-${product.id}`} height={100}>
                                             <Table.TextCell  flexBasis={100} flexGrow={0} flexShrink={0}>
                                                {(() => {
                                                    const inventoryItems = props.order.inventoryData.filter(inv =>
                                                        (inv.productId && inv.productId === product.id) ||
                                                        (inv.cardId && inv.cardId === product.id)
                                                    );

                                                    const { plCount, bvCount } = inventoryItems.reduce(
                                                        (acc, inv) => {
                                                            if (inv.stockAccountId === BV_STOCK_ACCOUNT_ID) {
                                                                acc.bvCount++;
                                                            } else {
                                                                acc.plCount++;
                                                            }
                                                            return acc;
                                                        },
                                                        { plCount: 0, bvCount: 0 }
                                                    );

                                                    return (
                                                        <>
                                                            {plCount > 0 && (
                                                                <Badge color="yellow" marginRight={4}>
                                                                    {plCount} PL
                                                                </Badge>
                                                            )}
                                                            {bvCount > 0 && (
                                                                <Badge color="blue">
                                                                    {bvCount} BV
                                                                </Badge>
                                                            )}
                                                        </>
                                                    );
                                                })()}
                                            </Table.TextCell>
                                            <Table.TextCell  flexBasis={100} flexGrow={0} flexShrink={0}>
                                                <img style={{height: '64px', width: 'auto'}}
                                                    alt="Product Thumbnail"
                                                    src={
                                                        product.type === 'product' && product.thumbnail ?
                                                                process.env.REACT_APP_IMAGE_STORAGE + '/thumb_' + product.thumbnail + '.webp'
                                                            :  product.type === 'card' && product.thumbnail ?
                                                                process.env.REACT_APP_CARD_IMAGE_BUCKET + '/' + product.thumbnail
                                                            : null
                                                        }/>
                                            </Table.TextCell>
                                            <Table.TextCell colspan="4">
                                                {product.preorder ? '(PRECOMANDA)' : ''}
                                                {product.sku || product.code} &nbsp;&nbsp;
                                                {product.title || (`${product.name} ${product.variantName}`)} &nbsp;&nbsp;
                                                <a target="_blank" rel="noopener noreferrer" href={product.title ? `/products/${product.id}` : `/cards/${product.id}`}>(Link)</a>
                                                {product.type === 'card' ?
                                                    <>
                                                        <div><strong>{moment(product.releaseDate).format('MM-YYYY')}</strong> / <strong>{product.rarity}</strong></div>
                                                    </>: ''}
                                            </Table.TextCell>
                                        </Table.Row>
                                        <Table.Row key={product.id}>
                                            <Table.TextCell>
                                                {product.price} Lei
                                            </Table.TextCell>
                                            <Table.TextCell>
                                                <Text fontSize="16px" fontWeight="bold" backgroundColor={product.quantity > 1 ? "red" : "green"} padding="5px" borderRadius="3px" color="white">
                                                    +{product.quantity}
                                                </Text>
                                            </Table.TextCell>

                                            <Table.TextCell>
                                                {product.quantity * product.price} Lei
                                            </Table.TextCell>

                                            <Table.TextCell>
                                                {(product.price) * product.quantity} Lei
                                            </Table.TextCell>
                                        </Table.Row>
                                        {product.quantityReturned > 0 ?
                                        <Table.Row key={product.id}>
                                            <Table.TextCell>
                                                {product.price} Lei
                                            </Table.TextCell>
                                            <Table.TextCell>
                                                {product.quantityReturned * -1}
                                            </Table.TextCell>

                                            <Table.TextCell>
                                                {product.quantityReturned * product.price * -1} Lei
                                            </Table.TextCell>
                                            <Table.TextCell>
                                                {(product.vatRate / 100) * (process.env.REACT_APP_FEATURE_VAT === 'false' ? 0 : 1) * product.price * product.quantityReturned * -1} Lei
                                            </Table.TextCell>
                                            <Table.TextCell>
                                                {((product.vatRate * (process.env.REACT_APP_FEATURE_VAT === 'false' ? 0 : 1) * product.price / 100) + product.price) * product.quantityReturned * -1} Lei
                                            </Table.TextCell>
                                        </Table.Row> : null
                                    }
                                    </>)) : null}

                                    {props.order.vouchers ? props.order.vouchers.map(voucher => (<>
                                        <Table.Row key={`voucher-pre-${voucher.id}`}>
                                            <Table.TextCell style={{color: "red"}} flexBasis={100} flexGrow={1} flexShrink={0} colspan="5">
                                            REDUCERE: {voucher.name} <br/>
                                            Cod: {voucher.code}
                                            </Table.TextCell>
                                            <Table.TextCell  style={{color: "red"}}>
                                                {-1 * voucher.value} Lei
                                            </Table.TextCell>
                                        </Table.Row>
                                    </>)) : null}
                                    {props.order.shippingCost > 0 ?
                                        <Table.Row>
                                            <Table.TextCell colspan="4" flexGrow={1}>
                                                <Icon icon={TruckIcon} marginRight={5}/>
                                                Transport
                                            </Table.TextCell>
                                            <Table.TextCell>
                                                {props.order.shippingCost} Lei
                                            </Table.TextCell>
                                        </Table.Row> : null}
                                    <Table.Row borderTop="1px solid black">
                                        <Table.TextCell>
                                            Subtotal
                                        </Table.TextCell>
                                        <Table.TextCell>
                                            {props.order.total} Lei
                                        </Table.TextCell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.TextCell>
                                            Reducere
                                        </Table.TextCell>
                                        <Table.TextCell>
                                            {-1 * (props.order.voucherValue) || 0} Lei
                                        </Table.TextCell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.TextCell>
                                        <Text fontWeight="bold">TOTAL</Text>
                                        </Table.TextCell>
                                        <Table.TextCell>
                                            <Text fontWeight="bold">{props.order.grandTotal} Lei</Text>
                                        </Table.TextCell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Pane>
                    </Pane>
                </Pane>
            </InfoBlock> : null}
            <InfoBlock
                flex="30%"
                marginRight={16}
                label={`Control Comanda`}
            >
                <Pane flexGrow="1">
                    <OrderControl order={props.order}
                        isAdmin={props.isAdmin}
                        updateOrderStatus={props.updateOrderStatus}
                        confirmOrderPayment={props.confirmOrderPayment}/>
                </Pane>
            </InfoBlock>
        </Pane>
    </Pane>
}
